import { defineComponent as _defineComponent } from 'vue'
import PdfFile from './icons/pdf-one.svg';
import PdfPrint from './icons/printer.svg';
import { computed } from 'vue';
import {historyDocumentPdfUrl} from "capitalist-shared/src/finance/documents";
import { getCurrentInstance } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DocumentDetailsPdfPanel',
  props: {
  id: {
    required: true
  }
},
  setup(__props) {

const props = __props;



const documentId = computed(() => Number(props.id));

const locale = computed(() => {
  return getCurrentInstance()?.proxy?.$i18n?.locale || 'en';
})

const printUrl = computed(() => {
  return historyDocumentPdfUrl(documentId.value as number, false, locale.value);
})

const downloadUrl = computed(() => {
  return historyDocumentPdfUrl(documentId.value as number, true, locale.value);
})

return { __sfc: true,props, documentId, locale, printUrl, downloadUrl, PdfFile, PdfPrint }
}

})